var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppVersion, getSystemType, SystemType, isDianpingAppOrWebview, isMiniProgramOrWebview } from '@nibfe/mkt-env-api';
import { getLBSInfo, getLocation } from '@nibfe/mkt-lbs-api';
import { getUserInfo } from '@nibfe/mkt-user-api';
export const isStandardKNB = /KNB\//i.test(navigator.userAgent) && /MSI\//i.test(navigator.userAgent);
/** 获取设备信息 */
export const getCommonInfo = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const commonParams = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams;
    const appVersion = getAppVersion();
    const systemType = getSystemType();
    const lbsResult = yield getLBSInfo({
        needLocation: true,
        sceneToken: 'dd-000e2fca8c104839'
    });
    ;
    const { lat, lng } = yield getLocation();
    const userInfo = yield getUserInfo();
    const platform = isDianpingAppOrWebview() ? 2 : 1;
    let uuid = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid) || (commonParams === null || commonParams === void 0 ? void 0 : commonParams.uuid);
    if (window === null || window === void 0 ? void 0 : window.inEditor) {
        uuid = 'F535010AC76E6B0D6C0EC4C59B5DB92A7B959FA923F1940CE2D4F21E02ADEE95';
    }
    console.log('usereererer info,', userInfo, 'commonParams', commonParams);
    const commonInfo = {
        clientVersion: appVersion,
        osType: systemType === SystemType.harmony ? 6 : systemType === SystemType.android ? 1 : 2,
        cityId: lbsResult === null || lbsResult === void 0 ? void 0 : lbsResult.homeSelectedCity,
        locateCityId: -1,
        userId: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) !== null && _b !== void 0 ? _b : commonParams === null || commonParams === void 0 ? void 0 : commonParams.userId,
        token: (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) !== null && _c !== void 0 ? _c : commonParams === null || commonParams === void 0 ? void 0 : commonParams.token,
        deviceId: uuid !== null && uuid !== void 0 ? uuid : '-1',
        clientType: 3,
        platform,
        terminalSource: isMiniProgramOrWebview() ? 5 : platform,
        lat,
        lng
    };
    return commonInfo;
});
